import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Calendar, MapPin } from 'lucide-react';
import { EVENT_NAME } from 'types';
import { Footer } from './shared/Footer';

const STEPS = [
  { path: '/', label: 'Select meals' },
  { path: '/review', label: 'Review' },
  { path: '/checkout', label: 'Pay' },
];

export default function Layout() {
  const { pathname } = useLocation();
  const step = STEPS.findIndex((s) => s.path === pathname);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="relative bg-gray-900 text-white">
        <img src="/images/ma-durga-face-right.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="relative max-w-6xl mx-auto px-4 py-8 flex items-center gap-4">
          <Link to="/"><img src="/images/logo.png" alt="Sanskriti e.V." className="w-16 h-16 rounded-full bg-white p-1" /></Link>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold">{EVENT_NAME} - Tickets</h1>
            <p className="text-sm text-gray-200 mt-1 flex flex-wrap gap-x-4">
              <span className="inline-flex items-center"><Calendar className="w-4 h-4 mr-1" />17 - 21 October 2026</span>
              <span className="inline-flex items-center"><MapPin className="w-4 h-4 mr-1" />Hamburg</span>
            </p>
          </div>
        </div>
      </header>

      {step >= 0 && (
        <ol className="max-w-6xl mx-auto w-full px-4 pt-6 flex gap-2 text-sm">
          {STEPS.map((s, i) => (
            <li key={s.path} className={`flex-1 border-t-4 pt-1 ${i <= step ? 'border-orange-500 text-orange-700 font-semibold' : 'border-gray-300 text-gray-400'}`}>
              {i + 1}. {s.label}
            </li>
          ))}
        </ol>
      )}

      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-6"><Outlet /></main>
      <Footer />
    </div>
  );
}
